// https://vuex.vuejs.org/en/mutations.html
import * as TYPES from './mutations-types'

/* eslint-disable no-param-reassign */
export default {
    [TYPES.SET_DOMAIN_LIST]: (state, list ) => {
        state.domains = list
    }
}



// WEBPACK FOOTER //
// ./src/app/company/vuex/mutations.js